module.exports = __webpack_public_path__ + "1031277af2f13f5e0a4fbbf893b2e095.png";